"use client";

import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, Award, Building2, CircleCheck, MapPin } from "lucide-react";
export default function RealEstateAdvocacy() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: badgesRef,
    isVisible: areBadgesVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <section data-section-id="109523" id="available-homes" className="dark bg-background text-foreground relative min-h-[85vh] flex items-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: "url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608256/img/orlando_skyline_sunset.png')"
      }} aria-hidden="true" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/90 to-background/20 md:to-transparent" />
        <div className="absolute inset-0 bg-background/40 md:hidden" /> {}
      </div>

      <div className="container mx-auto px-4 md:px-8 relative z-10 py-20 md:py-32">
        <div className="max-w-3xl">
          
          {}
          <div ref={badgesRef} className={`flex flex-wrap gap-3 mb-8 transition-all duration-1000 transform ${areBadgesVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Badge variant="secondary" className="rounded-full px-4 py-1.5 text-sm bg-chart-2/10 text-chart-2 border border-chart-2/30 backdrop-blur-sm">
              <Award className="w-4 h-4 mr-2 text-chart-2" />
              Trusted by Property Owners
            </Badge>
            <Badge variant="outline" className="rounded-full px-4 py-1.5 text-sm border-border/50 backdrop-blur-sm bg-background/50">
              <CircleCheck className="w-4 h-4 mr-2 text-chart-2" />
              Full-Service Management
            </Badge>
            <Badge variant="outline" className="rounded-full px-4 py-1.5 text-sm border-border/50 backdrop-blur-sm bg-background/50">
              <MapPin className="w-4 h-4 mr-2 text-chart-2" />
              Orlando, FL
            </Badge>
          </div>

          {}
          <div ref={contentRef} className={`transition-all duration-1000 delay-200 transform ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h1 className="font-sans text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-6 text-foreground"></h1>
            
            <p className="font-sans text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl leading-relaxed">
              Realsource Property Management helps owners maximize returns and reduce stress through elite management solutions across the Greater Orlando area.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="rounded-full px-8 text-base h-14 shadow-lg shadow-chart-2/20 bg-chart-2 hover:bg-chart-2/90 text-white border-none">
                
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-full px-8 text-base h-14 border-border/50 bg-background/50 backdrop-blur-sm hover:bg-accent hover:text-accent-foreground">
                
              </Button>
            </div>
          </div>

          {}
          

        </div>
      </div>
    </section>;
}